import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  faqBtn: {
    width: '65px !important',
    minWidth: '65px !important',
    height: '32px !important',
    minHeight: '32px !important',

    [theme.breakpoints.up('sm')]: {
      width: '82px !important',
      height: '36px !important',
    },
  },
});
